import { Injectable } from '@angular/core';
import { Urls } from '@core/config/urls';
import { IFields } from '@api/models/template-designer/IFields';
import { PrintPage } from '@api/models/template-designer/PrintItem';
import { LegacyBaseApiService } from '@smartera/core';
import { Observable } from 'rxjs';

@Injectable()
export class PrintTemplateService extends LegacyBaseApiService<any> {
	private _template: PrintPage;
	override get apiUrl() {
		return Urls.BASE_URL.toString() + '/main/print/templates';
	}

	public getFeilds(typeId: string): Observable<IFields[]> {
		return this._restClientService.get(`${this.apiUrl}/${typeId}/fields`);
	}
	public get template(): PrintPage {
		return this._template;
	}
	public set template(value: PrintPage) {
		this._template = value;
	}

	public downloadPrintDocument(typeId: string, referenceId: string) {
		return this._restClientService.get(`${this.apiUrl}/${typeId}/download-document/${referenceId}`, {
			responseType: 'blob',
		});
	}

	public getInvoicePrintdocument(id: string): Observable<any> {
		return this.downloadPrintDocument('SALE_INVOICE', id);
	}

	public getSaleBillPrintdocument(id: string): Observable<any> {
		return this.downloadPrintDocument('SALE_BILL', id);
	}

	public deletePhoto(templateId: string): Observable<any> {
		return this._restClientService.delete(`${this.apiUrl}/${templateId}/background-image`, null);
	}

	public uploadPhoto(templateId: string, file: any): Observable<any> {
		const formData = new FormData();
		formData.append('file', file);
		return this._restClientService.fileUpload(`${this.apiUrl}/${templateId}/background-image`, formData);
	}
}
